import type { ReactNode } from 'react';

const toneClass = {
  primary: 'bg-action-primary',
  danger: 'bg-status-danger',
  warning: 'bg-status-warning',
  success: 'bg-status-success',
} as const;

type StatCardProps = {
  label: string;
  value: ReactNode;
  tone: keyof typeof toneClass;
  icon: ReactNode;
};

export function StatCard({ label, value, tone, icon }: StatCardProps) {
  return (
    <div className="flex flex-1 items-center justify-between rounded-xl border border-border-default bg-bg-surface p-4">
      <div>
        <p className="text-[11px] font-medium text-text-secondary">{label}</p>
        <p className="mt-2 text-[26px] font-semibold leading-none text-text-primary">{value}</p>
      </div>
      <span
        className={`flex size-8 shrink-0 items-center justify-center rounded-[10px] text-sm text-text-inverse ${toneClass[tone]}`}
      >
        {icon}
      </span>
    </div>
  );
}
